import Moment from "moment";

import VendaContinuoService from "@/services/vendaContinuoService";

import BaseModel from "./base/baseModel";

export default class VendaContinuoModel extends BaseModel {
    id: number = null;
    vendaId: number = null;
    vendaItemId: number = null;
    dataVencimento: Date = null;
    ativo: boolean = null;
    clienteNome: string = null;
    pacienteNome: string = null;
    valor: number = null;
    valorAtualizado: number = null;
    orcado: boolean = null;
    dataConclusaoVenda?: Date = null;
    dataInclusao: Date = null;
    dataValidade?: Date = null;

    vendaContinuoService = new VendaContinuoService();

    //funcoes
    adiar(dias: number) {
        return this.vendaContinuoService.Adiar(this, dias);
    }
    arquivar() {
        return this.vendaContinuoService.Arquivar(this);
    }
    gerarOrcamento() {
        return this.vendaContinuoService.GerarOrcamento(this);
    }
    getTelefoneClientePadraoByVendaId(vendaId: number = null) {
        return this.vendaContinuoService.getTelefoneClientePadraoByVendaId(vendaId != null ? vendaId : this.vendaId);
    }
    getDiasSugestaoAdiar() {
        const dataComparar = this.dataConclusaoVenda != null ? this.dataConclusaoVenda : this.dataInclusao;

        const timeDiff = Moment(this.dataVencimento).diff(dataComparar);
        const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

        return Math.abs(diffDays);
    }
}

export interface VendaContinuoParameters {
    dataInicial?: string;
    dataFinal?: string;
}
